import React from "react";
import cx from "classnames";
// import { Common } from "@Api";
// import { collect } from "@Services/common";
import { collect } from "../../../services/common";
import styles from "./index.module.less";
import ga from "@Lib/ga";

export interface IListLink {
  id: number;
  type: number;
  title: string;
  thumb: string;
  time: string;
  visits: string;
  likes: number;
  comments: number;
  author: string;
  kindId: number;
  description: string;
  link: string;
  tags: string[];
}

interface IProps {
  dataSource:
    | IListLink
    | {
        [key: string]: any;
      };
  isCollect?: boolean;
  itemStyle?: React.CSSProperties;
}

// const { collect } = Common;

export const ListLinkLoading: React.FunctionComponent<IProps> = () => (
  <span className={styles["item"]}>
    <div className={cx(styles["thumb"], styles["loading"])} />
    <div className={styles["content"]}>
      <div className={cx(styles["title"], styles["loading"])} />
      <p className={styles["description"]}>
        <span className={styles["loading"]} />
        <span className={styles["loading"]} />
        <span className={styles["loading"]} />
      </p>
      <div className={styles["extra"]}></div>
      <div className={styles["footer"]}>
        <span className={styles["loading"]} />
        <span className={styles["loading"]} />
      </div>
    </div>
  </span>
);

const ListLink: React.FunctionComponent<IProps> = ({ dataSource, isCollect = true, itemStyle }) => {
  const { id, type, thumb, title, visits, likes, author, time, description, link, tags } = dataSource;
  return (
    <a
      className={cx(styles["item"])}
      style={itemStyle}
      href={link}
      target='_blank'
      data-id={id}
      onClick={() => {
        if (!isCollect) {
          return;
        }
        collect(id, type, "pc文章列表頁-推薦");
        ga(["文章首頁", "文章", "全部文章"]);
      }}
    >
      <img src={thumb} className={styles["thumb"]} />
      <div className={styles["content"]}>
        <h4 className={styles["title"]}>{title}</h4>
        <p className={styles["description"]}>{description}</p>
        <div className={styles["extra"]}>
          <div className={styles["extra-actions"]}>
            <div className={styles["extra-item"]}>
              <span className={styles["extra-visit-icon"]} />
              <span>{visits}</span>
            </div>
            <div className={styles["extra-item"]}>
              <span className={styles["extra-link-icon"]} />
              <span>{likes}</span>
            </div>
          </div>
          {tags && tags.length > 0 && <div className={styles["tag"]}>{tags[0]}</div>}
        </div>
        <div className={styles["footer"]}>
          <span>{author}</span>
          <span>{time}</span>
        </div>
      </div>
    </a>
  );
};

export default ListLink;
